import { render, staticRenderFns } from "./confirmationdialog.vue?vue&type=template&id=690bec40&"
import script from "./confirmationdialog.vue?vue&type=script&lang=ts&"
export * from "./confirmationdialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports